module.exports = __webpack_public_path__ + "static/media/logo-dark.7253fa78.svg";